<div class="evr-modal">

  <!-- Loading results -->
  <div *ngIf="loader && !affectLoader" class="evr-loading">
    <app-spinner text="{{'Analyse de tes réponses...' | translate}}"></app-spinner>
  </div>

  <!-- Applying level -->
  <div *ngIf="affectLoader" class="evr-loading">
    <app-spinner text="{{'Configuration de ta progression...' | translate}}"></app-spinner>
  </div>

  <!-- Results -->
  <div *ngIf="!loader && !affectLoader">

    <!-- No higher level -->
    <ng-container *ngIf="!response.higherLevel">
      <div class="evr-icon evr-icon-neutral">
        <i class="fa-solid fa-chart-bar"></i>
      </div>
      <div class="evr-title" translate>Test terminé !</div>
      <div class="evr-desc" translate>
        Les résultats de ton test ne permettent pas encore de passer à un niveau supérieur. Continue ta progression !
      </div>
      <div class="evr-actions">
        <button class="evr-btn-primary" (click)="goToCurrentLevel()" translate>
          Jouer maintenant
        </button>
      </div>
    </ng-container>

    <!-- Higher level unlocked -->
    <ng-container *ngIf="response.higherLevel">
      <div class="evr-icon evr-icon-success">
        <i class="fa-solid fa-rocket"></i>
      </div>
      <div class="evr-title" translate>Bravo !</div>
      <div class="evr-desc">
        {{ 'Ton test te permet d\'accéder au niveau' | translate }}
        <strong>{{ level?.name }}</strong>
        <strong *ngIf="level?.cefrl"> ({{ level.cefrl }})</strong>.
        {{ 'Souhaites-tu y accéder dès maintenant ?' | translate }}
      </div>
      <div class="evr-actions">
        <button class="evr-btn-primary" (click)="affectLevelAndRedirect()" translate>
          Accéder au niveau
        </button>
        <button class="evr-btn-link" (click)="goToDashboard()" translate>
          Non merci
        </button>
      </div>
    </ng-container>

  </div>

</div>
